/* DESTOCK FACTORY — theme.js (sans dépendance) */
(function () {
  'use strict';
  var DF = window.DF || {};

  function money(cents) {
    try {
      return new Intl.NumberFormat(DF.locale === 'en' ? 'en-GB' : 'fr-FR', { style: 'currency', currency: DF.currency || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  /* ---------- Toast + compteur panier ---------- */
  var toastTimer;
  function toast(text, isError) {
    var t = document.getElementById('CartToast');
    if (!t) return;
    t.querySelector('[data-toast-text]').textContent = text;
    t.classList.toggle('is-error', !!isError);
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 3800);
  }
  function refreshCount() {
    return fetch((DF.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
          el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
        });
      });
  }

  /* ---------- Quantité +/- ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 0;
    var min = parseInt(input.min || '0', 10);
    var step = parseInt(input.step || '1', 10);
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    v = b.getAttribute('data-qty') === 'plus' ? Math.min(max, v + step) : Math.max(min, v - step);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Panier : mise à jour auto des quantités ---------- */
  document.querySelectorAll('[data-cart-form] input[name="updates[]"]').forEach(function (input) {
    var t;
    input.addEventListener('change', function () {
      clearTimeout(t);
      t = setTimeout(function () { input.form.submit(); }, 450);
    });
  });

  /* ---------- Ajout au panier AJAX ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form]')) return;
    e.preventDefault();
    if (form.dataset.submitting === 'true') return;
    if (!form.reportValidity()) return;
    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value || variantInput.disabled) return;
    var section = form.closest('.km-product-section') || form.closest('section') || form;
    var btns = section.querySelectorAll('[data-add-btn]');
    var error = form.querySelector('[data-product-error]');
    if (error) { error.textContent = ''; error.hidden = true; }
    form.dataset.submitting = 'true';
    btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    fetch((DF.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { toast(DF.texts.added); return refreshCount().catch(function () {}); })
      .catch(function (err) {
        var message = (err && err.description) || DF.texts.error;
        toast(message, true);
        if (error) { error.textContent = message; error.hidden = false; }
      })
      .finally(function () {
        delete form.dataset.submitting;
        btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
      });
  });

  /* ---------- Fiche produit ---------- */
  function initProduct(root) {
    if (root.dataset.productInitialized) return;
    root.dataset.productInitialized = 'true';
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var mediaMapEl = root.querySelector('[data-media-map]');
    var mediaMap = mediaMapEl ? JSON.parse(mediaMapEl.textContent) : {};
    var translatedValues = {White:'Blanc', Black:'Noir', Brown:'Marron', Blue:'Bleu', Beige:'Beige', Red:'Rouge'};
    function displayOption(value, index) {
      var name = String(product.options[index] || '').toLowerCase();
      if (name === 'stockage' && /^\d+$/.test(value)) return value + ' Go';
      if (['color', 'colour', 'couleur'].indexOf(name) > -1) return translatedValues[value] || value;
      return value;
    }
    var form = root.querySelector('[data-product-form]');
    var idInput = form && form.querySelector('[name="id"]');
    var scope = root.closest('.km-product-section') || root.closest('section') || root;
    var addBtns = scope.querySelectorAll('[data-add-btn]');
    var priceEls = root.querySelectorAll('[data-price]');
    var stickyPrice = scope.querySelector('[data-sticky-price]');
    var stockEl = root.querySelector('[data-stock]');
    var fieldsets = root.querySelectorAll('[data-option-index]');

    function selectedOptions() {
      var out = [];
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        var select = fs.querySelector('select');
        out[+fs.getAttribute('data-option-index')] = checked ? checked.value : (select ? select.value : null);
      });
      return out;
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
      });
    }
    function priceHtml(v) {
      var h = '<span class="price__now">' + money(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        h += '<span class="price__was"><span class="price__label">' + (DF.compareLabel || '') + '</span><s>' + money(v.compare_at_price) + '</s></span>';
        if (root.hasAttribute('data-show-save')) {
          h += '<span class="price__save">-' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%</span>';
        }
      }
      return h;
    }
    function markUnavailable(opts) {
      fieldsets.forEach(function (fs) {
        var idx = +fs.getAttribute('data-option-index');
        fs.querySelectorAll('input').forEach(function (inp) {
          var test = opts.slice(0, idx + 1); test[idx] = inp.value;
          var match = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return test[i] == null || o === test[i]; });
          });
          var label = fs.querySelector('label[for="' + inp.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !match);
        });
        var legendVal = fs.querySelector('[data-selected-value]');
        if (legendVal) legendVal.textContent = displayOption(opts[idx] || '', idx);
        var spec = root.querySelector('[data-spec-option="' + idx + '"]');
        if (spec) spec.textContent = displayOption(opts[idx] || '', idx);
      });
    }
    function highlightGrade(opts) {
      var gi = product.options.findIndex(function (option) { return String(option).toLowerCase() === String(DF.gradeOption).toLowerCase(); });
      var grade = gi > -1 ? opts[gi] : null;
      root.querySelectorAll('[data-grade-row]').forEach(function (row) {
        var on = grade && row.getAttribute('data-grade-row').toLowerCase() === String(grade).toLowerCase();
        row.classList.toggle('is-active', !!on);
      });
      root.querySelectorAll('[data-grade-badge]').forEach(function (el) {
        if (grade) { el.textContent = grade; el.hidden = false; }
      });
    }
    function fileName(slide) {
      var img = slide.querySelector('img');
      if (!img) return '';
      try { return decodeURIComponent((img.getAttribute('src') || '').split('/').pop().split('?')[0]); }
      catch (e) { return ''; }
    }
    function filterMedia(opts, variant) {
      var slides = Array.from(root.querySelectorAll('[data-slide]'));
      var matching = mediaMap.files ? slides.filter(function (slide) { return mediaMap.files[fileName(slide)] === opts[mediaMap.optionIndex]; }) : [];
      slides.forEach(function (slide) {
        var group = mediaMap.files && mediaMap.files[fileName(slide)];
        slide.hidden = matching.length > 0 && !!group && group !== opts[mediaMap.optionIndex];
        var thumb = root.querySelector('[data-thumb="' + slide.dataset.slide + '"]');
        if (thumb) thumb.hidden = slide.hidden;
      });
      var visible = slides.filter(function (slide) { return !slide.hidden; });
      root.querySelectorAll('[data-gallery-nav]').forEach(function (button) { button.hidden = visible.length < 2; });
      var requested = variant && variant.featured_media && slides.find(function (slide) { return slide.dataset.slide == variant.featured_media.id && !slide.hidden; });
      var chosen = requested || matching[0];
      if (chosen) goTo(root, chosen.dataset.slide);
    }
    fieldsets.forEach(function (fieldset) {
      var index = +fieldset.dataset.optionIndex;
      fieldset.querySelectorAll('input').forEach(function (input) {
        var label = fieldset.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        var text = label.querySelector('.opt__name');
        if (text) text.textContent = displayOption(input.value, index);
        if (index !== mediaMap.optionIndex || !mediaMap.files) return;
        var slide = Array.from(root.querySelectorAll('[data-slide]')).find(function (slide) { return mediaMap.files[fileName(slide)] === input.value; });
        var source = slide && slide.querySelector('img');
        if (!source) return;
        var image = document.createElement('img');
        image.src = source.getAttribute('src');
        image.alt = ''; image.loading = 'lazy'; image.width = 64; image.height = 64;
        label.classList.add('opt__photo');
        fieldset.classList.add('opt--photos');
        label.prepend(image);
      });
    });
    function update() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      markUnavailable(opts);
      highlightGrade(opts);
      addBtns.forEach(function (b) {
        var label = b.querySelector('[data-add-label]') || b;
        if (!v) { b.disabled = true; label.textContent = DF.texts.unavailable; }
        else if (!v.available) { b.disabled = true; label.textContent = DF.texts.soldOut; }
        else { b.disabled = false; label.textContent = DF.texts.add; }
      });
      if (!v) {
        if (idInput) { idInput.value = ''; idInput.disabled = true; }
        priceEls.forEach(function (el) { el.textContent = DF.texts.unavailable; });
        if (stickyPrice) stickyPrice.textContent = DF.texts.unavailable;
        if (stockEl) { stockEl.className = 'stock stock--out'; stockEl.textContent = 'Cette combinaison n’existe pas'; }
        if (root.hasAttribute('data-update-url')) {
          var unavailableUrl = new URL(window.location.href);
          unavailableUrl.searchParams.delete('variant');
          window.history.replaceState({}, '', unavailableUrl.toString());
        }
        return;
      }
      if (idInput) { idInput.value = v.id; idInput.disabled = false; }
      priceEls.forEach(function (el) {
        el.innerHTML = priceHtml(v);
        el.classList.toggle('price--sale', v.compare_at_price > v.price);
      });
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (stockEl) {
        stockEl.className = 'stock' + (v.available ? '' : ' stock--out');
        stockEl.textContent = v.available ? stockEl.getAttribute('data-in') : stockEl.getAttribute('data-out');
      }
      filterMedia(opts, v);
      if (root.hasAttribute('data-update-url') && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    if (fieldsets.length) {
      var opts = selectedOptions();
      markUnavailable(opts);
      highlightGrade(opts);
      filterMedia(opts, findVariant(opts));
    }
  }

  /* ---------- Galerie ---------- */
  function goTo(root, mediaId) {
    var slides = root.querySelectorAll('[data-slide]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    slides.forEach(function (s) {
      var active = s.getAttribute('data-slide') == mediaId;
      s.classList.toggle('is-active', active);
      s.toggleAttribute('inert', !active);
      s.setAttribute('aria-hidden', String(!active));
      if (!active) s.querySelectorAll('video').forEach(function (video) { video.pause(); });
    });
    thumbs.forEach(function (t) {
      var on = t.getAttribute('data-thumb') == mediaId;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-pressed', String(on));
      if (on && t.parentElement) {
        var container = t.parentElement;
        if (t.offsetLeft < container.scrollLeft || t.offsetLeft + t.offsetWidth > container.scrollLeft + container.clientWidth) {
          container.scrollTo({ left: Math.max(0, t.offsetLeft - (container.clientWidth - t.offsetWidth) / 2), behavior: 'smooth' });
        }
      }
    });
  }
  function initGallery(root) {
    if (root.dataset.galleryInitialized) return;
    root.dataset.galleryInitialized = 'true';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    if (!slides.length) return;
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (t) { goTo(root, t.getAttribute('data-thumb')); return; }
      var nav = e.target.closest('[data-gallery-nav]');
      if (nav) {
        var i = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
        var visibleSlides = slides.filter(function (slide) { return !slide.hidden; });
        i = visibleSlides.findIndex(function (slide) { return slide.classList.contains('is-active'); });
        if (!visibleSlides.length) return;
        var n = (i + (nav.getAttribute('data-gallery-nav') === 'next' ? 1 : -1) + visibleSlides.length) % visibleSlides.length;
        goTo(root, visibleSlides[n].getAttribute('data-slide'));
      }
    });
    var x0 = null, main = root.querySelector('.gallery__main');
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) < 40) return;
        var btn = root.querySelector('[data-gallery-nav="' + (dx < 0 ? 'next' : 'prev') + '"]');
        if (btn) btn.click();
      });
    }
  }

  /* ---------- Barre d'achat collante ---------- */
  function initSticky() {
    document.querySelectorAll('[data-sticky-atc]').forEach(function (bar) {
      if (bar.dataset.initialized) return;
      bar.dataset.initialized = 'true';
      var section = bar.closest('section');
      var target = section && section.querySelector('[data-buy-anchor]');
      var submit = bar.querySelector('[data-sticky-submit]');
      if (!target || !submit || !('IntersectionObserver' in window)) return;
      var observer = new IntersectionObserver(function (entries) {
        if (!bar.isConnected) { observer.disconnect(); return; }
        var entry = entries[0];
        var visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', String(!visible));
        bar.toggleAttribute('inert', !visible);
        submit.tabIndex = visible ? 0 : -1;
      });
      observer.observe(target);
      submit.addEventListener('click', function () {
        var form = section.querySelector('[data-product-form]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    });
  }

  /* ---------- Tri collection ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sort]')) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Menu mobile : fermer avec Échap ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[open].drawer').forEach(function (d) { d.removeAttribute('open'); });
  });

  function init() {
    document.querySelectorAll('[data-product-root]').forEach(function (root) { initGallery(root); initProduct(root); });
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
